var cov_4toi8eplt = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/clone.ts",
      hash = "37699e4c368adc2c696d0dc654cab3f6865faac6",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/clone.ts",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 6,
          column: 100
        }
      },
      "1": {
        start: {
          line: 6,
          column: 56
        },
        end: {
          line: 6,
          column: 100
        }
      },
      "2": {
        start: {
          line: 6,
          column: 87
        },
        end: {
          line: 6,
          column: 99
        }
      },
      "3": {
        start: {
          line: 8,
          column: 20
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "4": {
        start: {
          line: 9,
          column: 15
        },
        end: {
          line: 9,
          column: 59
        }
      },
      "5": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "6": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 15,
          column: 5
        }
      },
      "7": {
        start: {
          line: 14,
          column: 6
        },
        end: {
          line: 14,
          column: 31
        }
      },
      "8": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 17,
          column: 66
        }
      },
      "9": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 20
        }
      },
      "10": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 15
        }
      },
      "11": {
        start: {
          line: 21,
          column: 3
        },
        end: {
          line: 24,
          column: 4
        }
      },
      "12": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 36
        }
      },
      "13": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 15
        }
      },
      "14": {
        start: {
          line: 28,
          column: 26
        },
        end: {
          line: 28,
          column: 76
        }
      },
      "15": {
        start: {
          line: 28,
          column: 40
        },
        end: {
          line: 28,
          column: 76
        }
      },
      "16": {
        start: {
          line: 30,
          column: 28
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "17": {
        start: {
          line: 31,
          column: 2
        },
        end: {
          line: 31,
          column: 22
        }
      },
      "18": {
        start: {
          line: 31,
          column: 12
        },
        end: {
          line: 31,
          column: 22
        }
      },
      "19": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 32,
          column: 39
        }
      },
      "20": {
        start: {
          line: 32,
          column: 19
        },
        end: {
          line: 32,
          column: 39
        }
      },
      "21": {
        start: {
          line: 33,
          column: 2
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "22": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "23": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 37
        }
      },
      "24": {
        start: {
          line: 34,
          column: 18
        },
        end: {
          line: 34,
          column: 37
        }
      },
      "25": {
        start: {
          line: 35,
          column: 2
        },
        end: {
          line: 35,
          column: 43
        }
      },
      "26": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 35,
          column: 43
        }
      },
      "27": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 56
        }
      },
      "28": {
        start: {
          line: 36,
          column: 20
        },
        end: {
          line: 36,
          column: 56
        }
      },
      "29": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 12
        }
      },
      "30": {
        start: {
          line: 40,
          column: 25
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "31": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "32": {
        start: {
          line: 41,
          column: 23
        },
        end: {
          line: 41,
          column: 48
        }
      },
      "33": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 53
        }
      },
      "34": {
        start: {
          line: 42,
          column: 27
        },
        end: {
          line: 42,
          column: 53
        }
      },
      "35": {
        start: {
          line: 43,
          column: 2
        },
        end: {
          line: 43,
          column: 29
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 19
          },
          end: {
            line: 6,
            column: 20
          }
        },
        loc: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 6,
            column: 100
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 75
          },
          end: {
            line: 6,
            column: 76
          }
        },
        loc: {
          start: {
            line: 6,
            column: 87
          },
          end: {
            line: 6,
            column: 99
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 8,
            column: 20
          },
          end: {
            line: 8,
            column: 21
          }
        },
        loc: {
          start: {
            line: 8,
            column: 82
          },
          end: {
            line: 26,
            column: 1
          }
        },
        line: 8
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 21,
            column: 52
          },
          end: {
            line: 21,
            column: 53
          }
        },
        loc: {
          start: {
            line: 21,
            column: 57
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 21
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 28,
            column: 26
          },
          end: {
            line: 28,
            column: 27
          }
        },
        loc: {
          start: {
            line: 28,
            column: 40
          },
          end: {
            line: 28,
            column: 76
          }
        },
        line: 28
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 30,
            column: 28
          },
          end: {
            line: 30,
            column: 29
          }
        },
        loc: {
          start: {
            line: 30,
            column: 42
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 30
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 40,
            column: 25
          },
          end: {
            line: 40,
            column: 26
          }
        },
        loc: {
          start: {
            line: 40,
            column: 42
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 40
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 51
          },
          end: {
            line: 8,
            column: 77
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 8,
            column: 75
          },
          end: {
            line: 8,
            column: 77
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 22
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 22
          }
        }, {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 31,
            column: 22
          }
        }],
        line: 31
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 39
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 39
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 37
          }
        }, {
          start: {
            line: 33,
            column: 2
          },
          end: {
            line: 33,
            column: 37
          }
        }],
        line: 33
      },
      "4": {
        loc: {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 37
          }
        }, {
          start: {
            line: 34,
            column: 2
          },
          end: {
            line: 34,
            column: 37
          }
        }],
        line: 34
      },
      "5": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        }, {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 43
          }
        }],
        line: 35
      },
      "6": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 56
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 56
          }
        }],
        line: 36
      },
      "7": {
        loc: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 48
          }
        }, {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 48
          }
        }],
        line: 41
      },
      "8": {
        loc: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 53
          }
        }, {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 53
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { isArray, isDate, isMap, isSet, isRegexp, isMergeable, isError } from './is';
cov_4toi8eplt.s[0]++;

// eslint-disable-next-line
var cloneArray = function cloneArray(source) {
  cov_4toi8eplt.f[0]++;
  cov_4toi8eplt.s[1]++;
  return Array.from(source, function (x) {
    cov_4toi8eplt.f[1]++;
    cov_4toi8eplt.s[2]++;
    return deepClone(x);
  });
};

cov_4toi8eplt.s[3]++;

var cloneObject = function cloneObject(source) {
  var specialKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_4toi8eplt.b[0][0]++, []);
  cov_4toi8eplt.f[2]++;
  var target = (cov_4toi8eplt.s[4]++, Object.create(Object.getPrototypeOf(source)));
  /* File or Response (non-serializable data) will throw error */

  cov_4toi8eplt.s[5]++;

  try {
    cov_4toi8eplt.s[6]++;

    // eslint-disable-next-line guard-for-in
    for (var key in target) {
      cov_4toi8eplt.s[7]++;
      target[key] = target[key];
    }
  } catch (e) {
    cov_4toi8eplt.s[8]++;
    console.error('should not pass non-serializable data', source);
    cov_4toi8eplt.s[9]++;
    console.error(e);
    cov_4toi8eplt.s[10]++;
    target = {};
  }

  ;
  cov_4toi8eplt.s[11]++;
  [].concat(_toConsumableArray(specialKeys), _toConsumableArray(Object.keys(source))).forEach(function (k) {
    cov_4toi8eplt.f[3]++;
    cov_4toi8eplt.s[12]++;
    // eslint-disable-next-line
    target[k] = deepClone(source[k]);
  });
  cov_4toi8eplt.s[13]++;
  return target;
};

cov_4toi8eplt.s[14]++;
export var fastClone = function fastClone(obj) {
  cov_4toi8eplt.f[4]++;
  cov_4toi8eplt.s[15]++;
  return JSON.parse(JSON.stringify(obj));
};
cov_4toi8eplt.s[16]++;
export var shallowClone = function shallowClone(val) {
  cov_4toi8eplt.f[5]++;
  cov_4toi8eplt.s[17]++;

  if (!val) {
    cov_4toi8eplt.b[1][0]++;
    cov_4toi8eplt.s[18]++;
    return val;
  } else {
    cov_4toi8eplt.b[1][1]++;
  }

  cov_4toi8eplt.s[19]++;

  if (isDate(val)) {
    cov_4toi8eplt.b[2][0]++;
    cov_4toi8eplt.s[20]++;
    return new Date(val);
  } else {
    cov_4toi8eplt.b[2][1]++;
  }

  cov_4toi8eplt.s[21]++;

  if (isMap(val)) {
    cov_4toi8eplt.b[3][0]++;
    cov_4toi8eplt.s[22]++;
    return new Map(val);
  } else {
    cov_4toi8eplt.b[3][1]++;
  }

  cov_4toi8eplt.s[23]++;

  if (isSet(val)) {
    cov_4toi8eplt.b[4][0]++;
    cov_4toi8eplt.s[24]++;
    return new Set(val);
  } else {
    cov_4toi8eplt.b[4][1]++;
  }

  cov_4toi8eplt.s[25]++;

  if (isRegexp(val)) {
    cov_4toi8eplt.b[5][0]++;
    cov_4toi8eplt.s[26]++;
    return new RegExp(val);
  } else {
    cov_4toi8eplt.b[5][1]++;
  }

  cov_4toi8eplt.s[27]++;

  if (isError(val)) {
    cov_4toi8eplt.b[6][0]++;
    cov_4toi8eplt.s[28]++;
    return cloneObject(val, ['message']);
  } else {
    cov_4toi8eplt.b[6][1]++;
  }

  cov_4toi8eplt.s[29]++;
  return val;
};
cov_4toi8eplt.s[30]++;
export var deepClone = function deepClone(source) {
  cov_4toi8eplt.f[6]++;
  cov_4toi8eplt.s[31]++;

  if (isArray(source)) {
    cov_4toi8eplt.b[7][0]++;
    cov_4toi8eplt.s[32]++;
    return cloneArray(source);
  } else {
    cov_4toi8eplt.b[7][1]++;
  }

  cov_4toi8eplt.s[33]++;

  if (isMergeable(source)) {
    cov_4toi8eplt.b[8][0]++;
    cov_4toi8eplt.s[34]++;
    return cloneObject(source);
  } else {
    cov_4toi8eplt.b[8][1]++;
  }

  cov_4toi8eplt.s[35]++;
  return shallowClone(source);
};